import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator } from './TagRulesCommon'


const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "TagProductsWhenTagExists",
    title: "Auto Tag Products When A Specific Tag Is Added",
    description: "Automatically tag products when a selected tag exists or is added. For example, add a week tag to products that have the 'new-arrivals' tag added to them.",
    example: "",
    additional: [],
    legacy: false,
    inProgress: false,
    previewType: "ProductTags",
    tags: ["Products", "Tags"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "TagProductsWhenTagExists",
                requiredTag: null,
                tagsToAdd: [],
                productStatuses: ["DRAFT", "ARCHIVED", "ACTIVE"],
                removeTagsIfRequiredTagIsMissing: true,
                skipAddTagsIfAlreadyAdded: true,
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {
                    if (rule.settings.requiredTag == null || rule.settings.requiredTag === "") {
                        errors["requiredTag"] = "Required tag must be specified";
                    }
                },
            ], null);
    }
};

export default ruleDefinition;